import type { Device } from "../../../../../../store/admin/devicesStore";
import { isSecondaryDevice, parentIdsOf } from "../../../../../../features/devices/pairing";

export interface AssignmentDeviceOption {
  value: string;
  label: string;
  isDisabled?: boolean;
}

interface AssignmentDeviceOptionsConfig {
  showPairing: boolean;
  keepDeviceId?: string;
  primaryLabel: string;
  secondaryLabel: string;
}

const baseLabel = (device: Device): string => {
  const vehicleName = device.vehicle?.name || "";
  const trailerName = device.remolque?.name || "";
  const name = vehicleName || trailerName ? device.identifier : device.name;
  return `${name} ${vehicleName ? `(${vehicleName})` : ""} ${trailerName ? `(${trailerName})` : ""}`.trim();
};

export const buildAssignmentDeviceOptions = (
  devices: Device[],
  { showPairing, keepDeviceId, primaryLabel, secondaryLabel }: AssignmentDeviceOptionsConfig,
): AssignmentDeviceOption[] => {
  const parents = parentIdsOf(devices);

  return devices
    .filter((device) => showPairing || !isSecondaryDevice(device) || device.id === keepDeviceId)
    .map((device) => {
      const secondary = isSecondaryDevice(device);
      const tag = showPairing
        ? secondary
          ? ` · ${secondaryLabel}`
          : parents.has(device.id)
            ? ` · ${primaryLabel}`
            : ""
        : "";
      return {
        value: device.id,
        label: `${baseLabel(device)}${tag}`,
        isDisabled: showPairing && secondary && device.id !== keepDeviceId,
      };
    });
};
